import { MobilePreviewImage, MobilePreviewCourse, PreviewMode } from './MobilePreview.type';

export class MobilePreviewService {
  
  // Converte dados do arquivo para formato de preview
  static formatFileForPreview(file: any, mediaType: string, title?: string, description?: string): MobilePreviewImage | null {
    if (!file || mediaType !== 'image') return null;

    // Tenta várias formas de obter a URI da imagem
    const uri = file.preview || file.uri || file.url || file.src;
    
    // Se não tem URI mas tem arquivo (upload em andamento), cria URL temporária
    if (!uri && file instanceof File) {
      const tempUri = URL.createObjectURL(file);
      return {
        uri: tempUri,
        uri_original: tempUri
      };
    }
    
    if (!uri) {
      return null;
    }

    return {
      uri,
      uri_original: file.uri_original || uri
    };
  }

  // Cria um curso mock para preview baseado no arquivo atual
  static createMockCourse(file: any, mediaType: string, title?: string, description?: string): MobilePreviewCourse {
    const image = this.formatFileForPreview(file, mediaType, title, description);
    
    return {
      id: 'preview-course',
      title: title || 'Preview do Curso',
      description: description || 'Visualização de como ficará a imagem no aplicativo móvel',
      cover: image,
      poster: image
    };
  }

  // Determina qual modo de preview usar baseado no aspect ratio da imagem
  static detectOptimalMode(file: any): PreviewMode {
    if (!file) return 'both';

    // Se tiver informações de dimensões, usar para determinar o melhor modo
    if (file.width && file.height) {
      const aspectRatio = file.width / file.height;
      
      // Aspect ratio próximo de 2:3 (0.67) = poster
      if (aspectRatio >= 0.6 && aspectRatio <= 0.75) {
        return 'poster';
      }
      
      // Aspect ratio próximo de 16:9 (1.78) = cover
      if (aspectRatio >= 1.5 && aspectRatio <= 2.0) {
        return 'cover';
      }
    }

    return 'both';
  }

  // Verifica se o arquivo é adequado para preview mobile
  static isValidForMobilePreview(file: any, mediaType: string): boolean {
    // Se não existe arquivo, retorna false
    if (!file) {
      return false;
    }
    
    // Se não é imagem, retorna false
    if (mediaType !== 'image') {
      return false;
    }
    
    // Verifica várias formas de URI que podem existir
    const hasValidUri = !!(
      file.preview ||     // Dropzone preview
      file.uri ||         // URI processada
      file.url ||         // URL direta
      file.src ||         // Source
      file.name ||        // Se tem nome, é um arquivo
      file.path ||        // Se tem path
      file.size           // Se tem size, é um arquivo
    );
    
    return hasValidUri;
  }

  // Gera dados de exemplo para demonstração
  static generateSampleCourses(currentImage?: MobilePreviewImage): MobilePreviewCourse[] {
    const sampleImages = [
      '/images/image-default-courses.png',
      '/images/image-default-courses-2.png', 
      '/images/image-default-courses-3.png',
      '/images/image-default-courses-4.png'
    ];

    return [
      {
        id: '1',
        title: 'Seu Curso',
        description: 'Preview da imagem que você está enviando',
        cover: currentImage,
        poster: currentImage
      },
      {
        id: '2',
        title: 'Treino Funcional',
        description: 'Exemplo de como fica com outros cursos',
        cover: { uri: sampleImages[0] },
        poster: { uri: sampleImages[0] }
      },
      {
        id: '3', 
        title: 'Yoga & Meditação',
        description: 'Curso de relaxamento e bem-estar',
        cover: { uri: sampleImages[1] },
        poster: { uri: sampleImages[1] }
      },
      {
        id: '4',
        title: 'HIIT Avançado', 
        description: 'Treino intervalado intensivo',
        cover: { uri: sampleImages[2] },
        poster: { uri: sampleImages[2] }
      }
    ];
  }
}
